export const LOW_HIT = 65
export const MID_HIT = 100
export const HIG_HIT = 150